<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    hasMiddleAuthors?: boolean
    showTime?: boolean
  }>(),
  {
    hasMiddleAuthors: false,
    showTime: false
  }
)

const dateWrapperClasses = computed(() => {
  return {
    'grow shrink-0 font-ui text-ui-xs text-secondary-foreground md:text-ui-md': true,
    'pt-2': true,
    'pt-0': !props.hasMiddleAuthors,
    'sm:text-right sm:self-end': !props.hasMiddleAuthors,
    'md:pt-0 md:text-right md:self-center': true
  }
})

</script>

<template>
  <div v-if="showTime"
       :class="dateWrapperClasses">
    <slot />
    {{ t('articleMeta.updatedDateTime') }}
  </div>

  <div v-else
       :class="dateWrapperClasses">
    <slot />
  </div>
</template>
